import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type {
  ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData,
  ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostError,
  ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostResponse,
} from '../../generated/types.gen';
import { multipartPost } from '../../utils';

export type BulkInviteValidateMutationVariables =
  ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData['path'] &
    ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData['body'];

export type BulkInviteValidateMutation =
  ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostResponse;

export const useBulkInviteValidateMutation = <
  TError = ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<BulkInviteValidateMutation, TError, BulkInviteValidateMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<BulkInviteValidateMutation, TError, BulkInviteValidateMutationVariables, TContext>({
    mutationKey: ['BulkInviteValidate'],
    mutationFn: ({ organization_id, file, role, scope_type, scope_ids }: BulkInviteValidateMutationVariables) =>
      multipartPost<BulkInviteValidateMutation>(
        '/v1/organizations/{organization_id}/users/bulk-invite/validate',
        file,
        { organization_id },
        { role, scope_type, scope_ids },
      ),
    ...options,
  });
};
